import dayjs from "dayjs";

const dateFormat = (item) => {
  ['regDate', 'beginDate', 'endDate'].forEach((key) => {
    if (!item[key]) {
      return;
    }
    item[key] = dayjs(item[key]).format('YYYY-MM-DD HH:mm:ss');
  });

  return item;
}

export default {
  SET_VIEW(state, view) {
    state.view = view;
  },
  SET_TESTBANK(state, testbank = {}) {
    state.testbank = testbank;
  },
  SET_TESTBANK_LIST(state, testbankList = {}) {
    testbankList.content?.map((testbank) => dateFormat(testbank));
    state.testbankList = testbankList;
  },
  SET_TESTBANK_LIST_FILTER(state, testbankListFilter) {
    state.testbankListFilter = {
      ...state.testbankListFilter,
      ...testbankListFilter,
    }
  },
  CREATE_TESTBANK(state, testbank) {
    testbank = dateFormat(testbank);
    state.testbankList.content.unshift(testbank);
  },
  DELETE_TESTBANK(state, testbank) {
    if (testbank.type === 'edit') {
      state.testbankList.content = state.testbankList.content.filter((item) => item.type !== 'edit');
      return;
    }
    state.testbankList.content = state.testbankList.content.filter((item) => item.bankId !== testbank.bankId);
  },
  SET_TESTBANK_EXAM_LIST_FILTER(state, testbankExamListFilter) {
    state.testbankExamListFilter = {
      ...state.testbankExamListFilter,
      ...testbankExamListFilter,
    }
  },
  SET_TESTBANK_EXAM_LIST(state, testbankExamList = {}) {
    testbankExamList.content?.map((testbankExam) => dateFormat(testbankExam));
    state.testbankExamList = testbankExamList;
  },
  SET_TESTBANK_EXAM(state, testbankExam = {}) {
    testbankExam = dateFormat(testbankExam);
    state.testbankExam = testbankExam;
  },

  DELETE_TESTBANK_EXAM(state, testbankExam = {}) {
    state.testbankExamList.content = state.testbankExamList.content.filter((item) => item.bankExamId !== testbankExam.bankExamId);
  },

  // 출제 이력 목록 설정
  SET_TESTBANK_EXAM_HISTORY_LIST(state, testbankExamHistoryList = {}) {
    testbankExamHistoryList.content?.map((exam) => dateFormat(exam));
    state.testbankExamHistoryList = testbankExamHistoryList;
  },

  // 출제 이력 목록 필터 설정
  SET_TESTBANK_EXAM_HISTORY_LIST_FILTER(state, testbankExamHistoryListFilter = {}) {
    state.testbankExamHistoryListFilter = {
      ...state.testbankExamHistoryListFilter,
      ...testbankExamHistoryListFilter,
    };
  },

  // 출제 이력 설정
  SET_TESTBANK_EXAM_HISTORY(state, testbankExamHistory = {}) {
    testbankExamHistory = dateFormat(testbankExamHistory);
    testbankExamHistory.roomExamUserList?.map((roomExamUser) => dateFormat(roomExamUser));
    state.testbankExamHistory = testbankExamHistory;
  },

  // 출제 이력 사용자 설정
  SET_TESTBANK_EXAM_HISTORY_USER(state, testbankExamHistoryUser = {}) {
    testbankExamHistoryUser = dateFormat(testbankExamHistoryUser);
    state.testbankExamHistoryUser = testbankExamHistoryUser;
  },
}
